import React, { useEffect, useState } from "react";
import HeroSection from "../components/home/HeroSection";
import EventStrip from "../components/home/EventStrip";
import LatestEvents from "../components/home/LatestEvents";
import AboutUs from "../components/home/AboutUs";
import Team from "../components/home/Team";
import EventGallery from "../components/home/EventGallery";
import Sponsors from "../components/home/Sponsors";
import API from "../config/axios";
import { api_paths } from "../config/api.paths";
import { useDispatch, useSelector } from "react-redux";
import { SET_LOADING } from "../redux/user";

function Home() {
  const [bannerData, setBannerData] = useState(null);
  const [upcomingEvents, setUpcomingEvents] = useState(null);

  const [otherDetails, setOtherDetails] = useState({
    aboutUs: null,
    committeeList: null,
    sponsorList: null,
    upcomingEvents: null,
    eventCalendarList: null,
    // eventGalleryList: null
  });
  const dispatch = useDispatch();

  const { loading } = useSelector((state) => state.USER_DATA);

  const fetchBannerData = async () => {
    try {
      dispatch(SET_LOADING(true));
      const response = await API.get(api_paths.member.HOME.GET_BANNER);

      const data = response.data?.payload?.result?.data || null;
      setBannerData(data);
      // console.log("Banner Data:", response.data);
      dispatch(SET_LOADING(false));
    } catch (error) {
      console.error("Error fetching banner data:", error);
      dispatch(SET_LOADING(false));
    } finally {
      dispatch(SET_LOADING(false));
    }
  };

  const fetchUpcomingEvents = async () => {
    try {
      dispatch(SET_LOADING(true));
      const response = await API.get(api_paths.member.HOME.GET_UPCOMING_EVENTS);
      const data = response.data?.payload?.result?.data || null;
      setUpcomingEvents(data);

      dispatch(SET_LOADING(false));
    } catch (error) {
      console.error("Error fetching banner data:", error);
      dispatch(SET_LOADING(false));
    } finally {
      dispatch(SET_LOADING(false));
    }
  };

  const fetchOtherDetails = async () => {
    try {
      dispatch(SET_LOADING(true));
      const response = await API.get(api_paths.member.HOME.GET_OTHER_DETAILS);

      const aboutUs = response.data?.payload?.result?.aboutUs || null;
      const committeeList =
        response.data?.payload?.result?.committeeList || null;
      const sponsorList = response.data?.payload?.result?.sponsorList || null;
      const upcomingEvents =
        response.data?.payload?.result?.upcomingEvents || null;
      // const eventGalleryList = response.data?.payload?.result?.eventGalleryList || null;
      const eventCalendarList =
        response.data?.payload?.result?.eventCalendarList;
      setOtherDetails({
        aboutUs,
        committeeList,
        sponsorList,
        upcomingEvents,
        // eventGalleryList
        eventCalendarList,
      });
      // console.log("Upcoming events data: ", response.data);

      dispatch(SET_LOADING(false));
    } catch (error) {
      console.error("Error fetching banner data:", error);
      dispatch(SET_LOADING(false));
    } finally {
      dispatch(SET_LOADING(false));
    }
  };

  useEffect(() => {
    fetchBannerData();
    fetchUpcomingEvents();
    fetchOtherDetails();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <section>
        <div className="container">
          <HeroSection bannerData={bannerData} loading={loading} />
          {otherDetails.eventCalendarList?.image_path && (
            <EventStrip calendar={otherDetails.eventCalendarList} />
          )}
          <LatestEvents
            nextMonthUpcomingEvents={otherDetails.upcomingEvents}
            loading={loading}
          />
          <AboutUs aboutUs={otherDetails.aboutUs} />
          <Team committeeList={otherDetails.committeeList} />
          {/* <EventGallery eventGalleryList={otherDetails.eventGalleryList} loading={loading}/> */}
          <EventGallery />
          <Sponsors sponsorList={otherDetails.sponsorList} />
        </div>
      </section>
    </>
  );
}

export default Home;
